import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "电影", to: "/category/movie" },
  { label: "电视剧", to: "/category/tvseries" },
  { label: "最新", to: "/category/latest" },
  { label: "热门", to: "/category/hot" },
  { label: "关于", to: "/about" },
];

export default function SiteHeader() {
  const navigate = useNavigate();
  const location = useLocation();
  const [keyword, setKeyword] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const kw = keyword.trim();
    navigate(kw ? `/search?q=${encodeURIComponent(kw)}` : "/search");
  };

  const isActive = (to: string) => {
    if (to === "/") return location.pathname === "/";
    return location.pathname.startsWith(to);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200/70"
          : "bg-gradient-to-b from-background-50/90 to-transparent"
      }`}
    >
      <div className="px-4 md:px-8 h-16 flex items-center gap-4 md:gap-8">
        <Link
          to="/"
          className="flex items-center gap-2 shrink-0 cursor-pointer"
          aria-label="蓝莓视频首页"
        >
          <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-foreground-950">
            <i className="ri-tv-2-fill text-xl"></i>
          </span>
          <span className="font-heading font-bold text-lg text-foreground-950 tracking-wide">
            蓝莓<span className="text-accent-500">视频</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1 flex-1">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`px-4 py-2 rounded-md text-sm whitespace-nowrap transition-colors cursor-pointer ${
                isActive(item.to)
                  ? "text-accent-500 font-medium"
                  : "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <form
          onSubmit={handleSearch}
          className="hidden md:flex items-center gap-2 flex-1 max-w-xs"
        >
          <div className="relative flex-1">
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-500 text-sm"></i>
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索影视名称"
              aria-label="搜索影视"
              className="w-full bg-background-100 border border-background-200 rounded-md pl-9 pr-3 py-2 text-sm text-foreground-950 placeholder:text-foreground-500 focus:outline-none focus:border-accent-500 transition-colors"
            />
          </div>
          <button
            type="submit"
            className="px-3 py-2 rounded-md bg-accent-500 text-background-50 text-sm whitespace-nowrap hover:bg-accent-600 transition-colors cursor-pointer"
          >
            搜索
          </button>
        </form>

        <div className="flex md:hidden items-center gap-2 ml-auto">
          <Link
            to="/search"
            className="w-9 h-9 flex items-center justify-center rounded-md text-foreground-700 hover:text-foreground-950 cursor-pointer"
            aria-label="搜索"
          >
            <i className="ri-search-line text-xl"></i>
          </Link>
          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            className="w-9 h-9 flex items-center justify-center rounded-md text-foreground-950 cursor-pointer"
            aria-label="菜单"
          >
            <i className={menuOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-3 animate-fade-in">
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`px-3 py-3 rounded-md text-sm cursor-pointer ${
                  isActive(item.to)
                    ? "text-accent-500 bg-background-100 font-medium"
                    : "text-foreground-700"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}